var main = {
    jsToggles: function() {
        var linkToggle = document.querySelectorAll('.js-toggle');

        linkToggle.forEach(toggle => {
            toggle.addEventListener('click', function (event) {
                event.preventDefault();
        
                var container = document.getElementById(this.dataset.container);
                var parent = toggle.closest('.accordion-parent');
        
                if ( parent != null ) {
                    // Close other tabs first
                    const otherTabs = [...parent.querySelectorAll('.js-toggle')].filter(tab => tab !== toggle);
                    otherTabs.forEach(t => {
                        var containerChild = document.getElementById(t.dataset.container);
            
                        // Only close if the tab is open
                        if (t.classList.contains('is-open')) {
                            t.classList.remove('is-open');
                            containerChild.style.height = '0px';
            
                            if (containerChild.classList.contains('no-trans')) {
                                containerChild.classList.remove('active');
                            } else {
                                containerChild.addEventListener('transitionend', function handleTransition() {
                                    containerChild.classList.remove('active');
                                    containerChild.removeEventListener('transitionend', handleTransition); // Remove listener after closing
                                });
                            }
                        }
                    });
                }
        
                // Handle the current toggle
                if (!container.classList.contains('active')) {
                    // Open the clicked tab
                    this.classList.add('is-open');
                    container.classList.add('active');
        
                    // Set height for transition
                    container.style.height = 'auto';
                    var height = container.clientHeight + 'px';
                    container.style.height = '0px'; // Set to 0 first for the transition to kick in
        
                    // Trigger height transition
                    setTimeout(function () {
                        container.style.height = height;

                        if (container.classList.contains('scroll-view')) {
                            // Scroll the content into the middle of the screen
                            container.scrollIntoView({
                                behavior: 'smooth',      // Smooth scrolling
                                block: 'center',         // Align the content to the center of the screen
                                inline: 'nearest'        // Prevent unnecessary horizontal scrolling
                            });
                        }
                    }, 0);

                    // Trigger height transition


                    // Handle parent container if needed
                    var parentContainer = container.closest('.sub-parent');
                    if (parentContainer != null && parentContainer.clientHeight > 0) {
                        setTimeout(function () {
                            parentContainer.style.height = 'auto';
                            var parentHeight = parentContainer.clientHeight + 'px';
                            parentContainer.style.height = '0px';
                            parentContainer.style.height = parentHeight;
                        }, 100);
                    }
                } else {
                    // Close the clicked tab
                    this.classList.remove('is-open');
                    container.style.height = '0px';
        
                    if (container.classList.contains('no-trans')) {
                        container.classList.remove('active');
                    } else {
                        container.addEventListener('transitionend', function handleTransition() {
                            container.classList.remove('active');
                            container.removeEventListener('transitionend', handleTransition); // Remove listener after closing
                        });
                    }
        
                    // Adjust the parent height if necessary
                    var parentContainer = container.closest('.sub-parent');
                    var innerSub = container.closest('.inner-sub');
        
                    if (innerSub != null) {
                        setTimeout(function () {
                            parentContainer.style.height = innerSub.clientHeight + 'px';
                        }, 100);
                    }
                }
            });

            if (toggle.classList.contains('is-open')) {
                toggle.click()
            }
        });
        
    },
    swipeSlider: function() {
        const screenWidth = window.innerWidth || document.documentElement.clientWidth;
    
        if (screenWidth >= 750) {
            const slides = document.querySelectorAll('.slide-draggable');


            slides.forEach(slider=> {
                let mouseDown = false;
                let startX, scrollLeft;
        
                if (typeof slider !== 'undefined' && slider !== null) {
                    let startDragging = function (e) {
                        mouseDown = true;
                        startX = e.pageX - slider.offsetLeft;
                        scrollLeft = slider.scrollLeft;
                    };
                    let stopDragging = function (event) {
                        mouseDown = false;
                    };
        
                    slider.addEventListener('mousemove', (e) => {
                        e.preventDefault();
                        if (!mouseDown) { return; }
                        const x = e.pageX - slider.offsetLeft;
                        const scroll = x - startX;
                        slider.scrollLeft = scrollLeft - scroll;
                    });
        
                    // Add the event listeners
                    slider.addEventListener('mousedown', startDragging, false);
                    slider.addEventListener('mouseup', stopDragging, false);
                    slider.addEventListener('mouseleave', stopDragging, false);
                }
            })

        }
    },
    tabSection: function() {
        document.querySelectorAll('.tab-pill-item').forEach(e=> {
            e.addEventListener('click', function() {
                
                if (e.querySelector('.js-toggle')) {
                    e.querySelector('.js-toggle').click()
                }

                document.querySelectorAll('.image-tab-item').forEach(img => {

                    if (img.dataset.id == e.dataset.id) {
                        img.removeAttribute('hidden')
                    } else {
                        img.setAttribute('hidden','')
                    }
                })

                document.querySelectorAll('.tab-pill-item').forEach(pill=> {
                    if (pill != e) {
                        pill.classList.remove('active')
                    } else {
                        pill.classList.add('active')
                    }
                })
            })
        })
    },
    slideAdapt: function() {
        const activeSlide = document.querySelectorAll('.product__media-item')[0]
        if (activeSlide) {
            slideAdapt(activeSlide)
        }

        document.querySelectorAll('.slide-adaptable').forEach(e=> {

            e.addEventListener('slideChanged', function(evt) {
                slideAdapt(evt.detail)
            })
        })
        
        function slideAdapt(e) {

            var contentHeight = 0
            var slideList = 0

            if (typeof(e.currentElement) != "undefined") {

                contentHeight = e.currentElement?.querySelector('.product-media-container').clientHeight
                slideList = e.currentElement.closest('.slider')
            } else {
                contentHeight = e.querySelector('.product-media-container').clientHeight
                slideList = e.closest('.slider')
            }

            slideList.style.height = contentHeight + 'px';
        }
    },
    scrollView: ()=> {
        document.querySelectorAll('a[href*="#"]').forEach(e => {
            e.addEventListener('click', function (evt) {
                evt.preventDefault();
        
                const href = e.getAttribute('href');
                const fragment = href.split('#')[1]; // Extract the fragment identifier
        
                if (fragment) {
                    const el = document.getElementById(fragment);
        
                    if (el) {
                        var topPosition = el.getBoundingClientRect().top + window.scrollY;
        
                        // Scroll to the top position with smooth behavior
                        window.scrollTo({
                            top: topPosition,
                            behavior: 'smooth'
                        });
                    } else {
                        console.log('Element not found');
                    }
                }
            });
        });
    },
    stickyButton: ()=> {

        const offerBlock = document.querySelector('.product-form__buttons');
        const stickyPanel = document.querySelector('.sticky--button');
        const stickyButton = stickyPanel?.querySelector('.button--sticky-atc')
        var items = [];

        if (offerBlock && stickyPanel) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Remove 'active' class when offerBlock is visible
                        stickyPanel.classList.remove('active');
                    } else {
                        // Add 'active' class when offerBlock is not visible
                        stickyPanel.classList.add('active');
                    }
                });
            }, { threshold: 0.2 }); // Adjust threshold as needed
        
            observer.observe(offerBlock);
        
            stickyButton?.addEventListener('click', function() {
                const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                const form = document.getElementById(stickyButton.dataset.form);
                stickyButton.classList.add('loading'); 
                stickyButton.querySelector('.loading__spinner').classList.remove('hidden');

                items.push({
                    id: Number(this.getAttribute('data-variant-id')), // or modify based on the actual structure
                    quantity: 1
                });

                var formData = {
                    'items': items
                };

                if (cart) {
                    formData.sections = cart.getSectionsToRender().map((section) => section.id);
                    formData.sections_url = window.location.pathname;
                    cart.setActiveElement(document.activeElement);
                    cart.classList.remove('is-empty')
                }

                if (stickyButton.classList.contains('in-cart')) {
                    if (!cart) {
                        window.location = window.routes.cart_url;
                        return;
                    } else {
                        cart.open(stickyButton)
                    }

                    stickyButton.classList.remove('loading'); 
                    stickyButton.querySelector('.loading__spinner').classList.add('hidden');
                } else {
                    
                    // Perform the fetch request
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    })
                    .then(response => response.json())
                    .then(response => {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            form: form,
                            source: 'product-form',
                            productVariantId: response.items[0].variant_id,
                            cartData: response,
                            cart: cart
                        });
                        stickyButton.classList.add('in-cart')

                        cart.renderContents(response);
                    }).finally(() => {
                        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

                        stickyButton.classList.remove('loading'); 
                        stickyButton.querySelector('.loading__spinner').classList.add('hidden');
                    });
                }


            });
        }
    }
}

main.jsToggles()
main.swipeSlider()
main.tabSection()
main.slideAdapt()
main.stickyButton()
main.scrollView()

window.addEventListener('resize', () => {
    main.slideAdapt()
});

// js/common/behavior/scroll-progress.js
var ScrollProgress = class extends HTMLElement {
    connectedCallback() {
      this.scrolledElement.addEventListener("scroll", throttle(this._updateScrollProgress.bind(this)));
      if (window.ResizeObserver) {
        new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement);
      }
    }
    get scrolledElement() {
      return this._scrolledElement = this._scrolledElement || document.getElementById(this.getAttribute("observes"));
    }
    _updateScrollProgress() {
      const scrollLeft = document.dir === "ltr" ? this.scrolledElement.scrollLeft : Math.abs(this.scrolledElement.scrollLeft), advancement = (scrollLeft + this.scrolledElement.clientWidth) / this.scrolledElement.scrollWidth;
      this.style.setProperty("--scroll-progress", Math.max(0, Math.min(advancement, 1)).toFixed(6));
    }
  };
if (!window.customElements.get("scroll-progress")) {
    window.customElements.define("scroll-progress", ScrollProgress);
}

subscribe('variant-change', (eventData) => {
    // Log the event data
    const variant = eventData.data.variant

    document.querySelectorAll('.var-inclusion').forEach(e=> {
        if (e.dataset.id && Number(e.dataset.id) == variant.id) {
            e.removeAttribute('hidden')
        } else {
            e.setAttribute('hidden','')
        }
    })

    document.querySelectorAll('.variant-specs').forEach(e=> {
        if (e.dataset.id && Number(e.dataset.id) == variant.id) {
            e.removeAttribute('hidden')
        } else {
            e.setAttribute('hidden','')
        }
    })

    if (variant.available == false) {
        document.querySelector('.sticky--button').setAttribute('hidden','')
        // document.querySelector('.sticky--button').querySelector('.button--sticky-atc .text').textContent = window.variantStrings.soldOut
    } else {
        // document.querySelector('.sticky--button').querySelector('.button--sticky-atc .text').textContent = window.variantStrings.addToCart
        document.querySelector('.sticky--button').removeAttribute('hidden')
    }

    if (document.querySelector('.button--sticky-atc') != null) {
        const stickyButton = document.querySelector('.button--sticky-atc')

        stickyButton.setAttribute('data-variant-id', variant.id);

        fetch('/cart.js').then(response => {
            return response.json();
        })
        .then(cartData => { 
            const foundVariant = cartData.items.find(item => item.variant_id == variant.id) 
            
            if (foundVariant != undefined) {
                stickyButton.classList.add('in-cart');
                stickyButton.querySelector('.text').textContent = stickyButton.dataset.viewCart
            } else {
                stickyButton.classList.remove('in-cart');
                stickyButton.querySelector('.text').textContent = window.variantStrings.addToCart
            }
        })
        .catch(error => {
            console.error('Error fetching shopping cart data:', error);
        });
    }
});

subscribe('cart-update', (eventData) => {

    if (eventData.source == 'product-form') {
        document.querySelector('.button--sticky-atc')?.classList.remove('loading'); 
        document.querySelector('.button--sticky-atc')?.querySelector('.loading__spinner').classList.add('hidden');

        if (eventData.productVariantId != undefined && document.querySelector('.button--sticky-atc') != null) {
            document.querySelector('.button--sticky-atc').setAttribute('data-variant-id', eventData.productVariantId);
    
            if (eventData.productVariantId == Number(document.querySelector('.button--sticky-atc').getAttribute('data-variant-id'))) {
                document.querySelector('.button--sticky-atc .text').textContent = document.querySelector('.button--sticky-atc').dataset.viewCart
                document.querySelector('.button--sticky-atc').classList.add('in-cart')
            }
        }
    }

    if (eventData.source == 'cart-items') {
        const cart = eventData.cartData
        if (cart.items_removed[0].product_id == Number(document.querySelector('.button--sticky-atc').getAttribute('data-product-id'))) {
            document.querySelector('.button--sticky-atc .text').textContent = window.variantStrings.addToCart
            document.querySelector('.button--sticky-atc').classList.remove('in-cart')
        }
    }
});


document.querySelectorAll('.bundle-list-link, .bundle-image-first').forEach(e=> {
    e.addEventListener('click', function(evt) {
        evt.preventDefault()

        const modal = document.querySelector(this.getAttribute('data-modal'));
        const slider = modal.querySelector('[id^="Slider-"]');
        const sliderItems = slider.querySelectorAll('[id^="Slide-"]');

        const sliderItemsToShow = Array.from(sliderItems).filter((element) => element.clientWidth > 0);
        const sliderItemOffset = sliderItemsToShow[1].offsetLeft - sliderItemsToShow[0].offsetLeft;

        const activeSlide = slider.querySelector(`.slider__slide[data-id="${e.dataset.id}"]`)
        const slideScrollPosition = activeSlide.offsetLeft - sliderItemsToShow[0].offsetLeft;

        modal.querySelector('slideshow-component').setSlidePosition(slideScrollPosition);

        const contents = modal.querySelectorAll('.include--slider-content');

        contents.forEach(c=> {
            if (c.dataset.id == e.dataset.id) {
                c.removeAttribute('hidden')
            } else {
                c.setAttribute('hidden','')
            }
        })

        if (modal) modal.show(e);
    })
})

document.querySelectorAll('.modal-include slideshow-component').forEach(slider=> {
    const sliderItems = slider.querySelectorAll('[id^="Slide-"]');

    slider.addEventListener('slideChanged', function(evt) {

        const activeSlide = evt.detail.currentElement

        if (activeSlide == undefined) return;

        const blockId = activeSlide.dataset.id
        const modal = slider.closest('.modal-include')

        const contents = modal.querySelectorAll('.include--slider-content');

        contents.forEach(c=> {
            if (c.dataset.id == blockId) {
                c.removeAttribute('hidden')
            } else {
                c.setAttribute('hidden','')
            }
        })
    })
})

class VideoMedia extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
  
    init() {
      if (this.getAttribute('loaded')) return;

      new IntersectionObserver(([entry], observer) => {
        if (!entry.isIntersecting) return;
        
        this.loadContent();
        observer.disconnect();
      }, { threshold: 0.1, once: true }).observe(this);
    }
  
    loadContent() {
      this.setAttribute('loaded', true);
      this.querySelector('img')?.remove();
  
      // Extract content from <noscript> and parse it
      const templateString = this.querySelector('noscript')?.textContent.trim();
      if (!templateString) return;
  
      const parser = new DOMParser();
      const doc = parser.parseFromString(templateString, 'text/html');
      const video = doc.querySelector('video');
  
      if (video) {
        this.appendChild(video);
        video.play().catch(err => console.warn("Autoplay failed:", err));
      }
    }
}
  
customElements.define('video-media', VideoMedia);